module.exports = __webpack_public_path__ + "static/media/phone-volume.3c8f369b.svg";